/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import {
  ControlProps,
  RankedTester,
  rankWith,
  isStringControl,
  and,
  schemaMatches
} from '@jsonforms/core'

import { withJsonFormsControlProps } from '@jsonforms/react'
import { withHandleChangeEmitter } from '../WithCustomHandlerHOC'

export const PhoneNumber: React.FC<ControlProps> = (props: ControlProps) => {
  const {
    label,
    handleChange,
    data,
    path,
    id,
    errors,
    schema,
    required,
    visible,
    enabled
  } = props

  const [showError, setShowError] = useState<boolean>(false)
  const newformattedData =
    data && data.length >= 1
      ? data.replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3')
      : '' // format the phone number as (000)000-0000
  const [unformattedPhoneNumber, setunformattedPhoneNumber] =
    useState(newformattedData)

  const validate = () => {
    required && !unformattedPhoneNumber
      ? setShowError(true)
      : setShowError(false)
  }

  const getClass = () => {
    return errors && errors.length ? 'form-control is-invalid' : 'form-control'
  }

  const handlePhoneNumberChange = (e: any) => {
    const inputPhoneNumber = e.target.value.replace(/\D/g, '').substring(0, 10) // remove all non-numeric characters and limit to 10 digits
    const phoneNumberFormatted = inputPhoneNumber.replace(
      /(\d{3})(\d{3})(\d{4})/,
      '($1)$2-$3'
    ) // format the phone number as (000)000-0000
    setunformattedPhoneNumber(phoneNumberFormatted)
    const tempPhone = phoneNumberFormatted.replace(/[-)()]/g, '')
    handleChange(path, tempPhone)
    validate()
  }

  return (
    <>
      {visible ? (
        <div className='form-group'>
          <label htmlFor={id} className='custom-input-label'>
            {label}
          </label>
          <input
            type='text'
            id={id}
            name='input-name'
            className={getClass()}
            onChange={handlePhoneNumberChange}
            onBlur={() => {
              validate()
            }}
            value={unformattedPhoneNumber}
            pattern='[0-9]*'
            disabled={!enabled}
            data-testid='phone-number'
          />

          {(!!errors || showError) && (
            <div className='text-danger'>
              <span>{`${schema.title} is required`}</span>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export const phoneNumberControlTester: RankedTester = rankWith(
  7,
  and(
    isStringControl,
    schemaMatches(
      // eslint-disable-next-line
      (schema: { hasOwnProperty: (arg0: string) => any }) =>
        // eslint-disable-next-line no-prototype-builtins
        schema.hasOwnProperty('isPhoneNumber')
    )
  )
)

export const PhoneNumberControl = withJsonFormsControlProps(
  withHandleChangeEmitter(PhoneNumber)
)
